const es: Record<string, string> = {
  // Navbar
  nav_inicio: 'Inicio',
  nav_sobre: 'Sobre Nosotros',
  nav_que: 'Qué Hacemos',
  nav_productos: 'Productos',
  nav_contacto: 'Contacto',
  lang_switch: 'EN',

  // Hero
  hero_title: 'Envasado y distribución de aceites con calidad y seguridad',
  hero_btn_products: 'Ver productos',
  hero_btn_info: 'Solicitar información',

  // About
  about_label: 'Sobre Nosotros',
  about_title: 'Comprometidos con la',
  about_title_accent: 'calidad operativa',
  about_p1: 'Merandia es una empresa dedicada al envasado, almacenamiento y distribución de aceites de palma y soya. Nuestra actividad se centra en garantizar que cada producto llegue al cliente en condiciones óptimas, cumpliendo con los más altos estándares de inocuidad y trazabilidad.',
  about_p2: 'Contamos con instalaciones especializadas para el manejo seguro de aceites en volumen, aplicando protocolos rigurosos de control de calidad en cada etapa del proceso logístico: recepción, envasado, almacenamiento y despacho.',
  about_feat1: 'Control de calidad certificado',
  about_feat2: 'Distribución nacional',
  about_feat3: 'Almacenamiento especializado',
  about_feat4: 'Trazabilidad completa',

  // Process
  process_label: 'Nuestras Operaciones',
  process_title: '¿Qué hacemos?',
  process_subtitle: 'Nos especializamos en tres actividades clave que garantizan que el aceite llegue a tu negocio en perfectas condiciones',
  process_service: 'Servicio',

  process_1_title: 'Envasado',
  process_1_desc: 'Envasamos aceites de palma y soya en diversas presentaciones: botellas de 250ml, 430ml, 500ml, 830ml, 900ml, 1L, 9L y garrafas de 20L, bajo estrictos protocolos de higiene y seguridad alimentaria.',
  process_1_d1: 'Líneas de envasado de alta capacidad',
  process_1_d2: 'Control de hermeticidad y peso',
  process_1_d3: 'Etiquetado según normativas nacionales',
  process_1_d4: 'Trazabilidad por lote de producción',

  process_2_title: 'Almacenamiento',
  process_2_desc: 'Disponemos de bodegas climatizadas y adecuadas para el manejo seguro de aceites en volumen, con control de temperatura, humedad y condiciones sanitarias certificadas.',
  process_2_d1: 'Bodegas de temperatura controlada',
  process_2_d2: 'Sistema FIFO para rotación de inventario',
  process_2_d3: 'Monitoreo continuo de condiciones',
  process_2_d4: 'Capacidad para almacenamiento a granel',

  process_3_title: 'Distribución',
  process_3_desc: 'Distribuimos nuestros productos a distribuidores, comercios, supermercados y mayoristas en todo Honduras, garantizando tiempos de entrega y condiciones de transporte adecuadas.',
  process_3_d1: 'Cobertura nacional en Honduras',
  process_3_d2: 'Flota de transporte adecuada',
  process_3_d3: 'Seguimiento logístico de pedidos',
  process_3_d4: 'Distribución a mayoristas y minoristas',

  // Stats / Why us
  stats_label: 'Nuestras Fortalezas',
  stats_title: '¿Por qué elegirnos?',
  stats_subtitle: 'Somos un aliado confiable para distribuidores y negocios que necesitan abastecerse de aceites con garantía de calidad',

  stats_1_value: 'Calidad',
  stats_1_label: 'Garantizada',
  stats_1_desc: 'Cada lote pasa por controles de calidad rigurosos antes de ser despachado, asegurando que el producto cumpla con las normativas alimentarias vigentes.',

  stats_2_value: 'Cumplimiento',
  stats_2_label: 'Normativo',
  stats_2_desc: 'Operamos bajo estrictas normativas de inocuidad alimentaria, con procesos documentados y trazables en cada etapa de nuestra cadena operativa.',

  stats_3_value: 'Eficiencia',
  stats_3_label: 'Logística',
  stats_3_desc: 'Nuestra capacidad operativa nos permite responder con agilidad a los pedidos, asegurando entregas a tiempo y en condiciones óptimas a nivel nacional.',

  stats_feat1: 'Cobertura nacional en Honduras',
  stats_feat2: 'Aceites de palma y soya',
  stats_feat3: 'Múltiples presentaciones',
  stats_feat4: 'Atención comercial directa',

  // Products
  products_label: 'Catálogo',
  products_title: 'Nuestros Productos',
  products_subtitle: 'Explora nuestro portafolio de marcas y presentaciones disponibles para distribución',
  products_all_brands: 'Todas las marcas',
  products_presentations: 'Presentaciones',
  products_available: 'Disponible en',
  products_request_btn: 'Solicitar información',
  products_view_btn: 'Ver detalle',
  products_close: 'Cerrar',
  products_vegetal: 'Aceite Vegetal',
  products_soya: 'Aceite de Soya',
  products_palma: 'Oleína de Palma',

  // Alimorca brand
  brand_alimorca_name: 'Alimorca',
  brand_alimorca_desc: 'Aceite de soya reconocido por el público en sus distintas presentaciones, del botellón familiar al balde industrial.',
  alimorca_1_name: 'Alimorca Aceite de Soya 430ml',
  alimorca_1_pres: '430ml',
  alimorca_2_name: 'Alimorca Aceite de Soya 500ml',
  alimorca_2_pres: '500ml',
  alimorca_3_name: 'Alimorca Aceite de Soya 750ml',
  alimorca_3_pres: '750ml',
  alimorca_4_name: 'Alimorca Aceite de Soya 828ml',
  alimorca_4_pres: '828ml',
  alimorca_5_name: 'Alimorca Aceite de Soya 900ml',
  alimorca_5_pres: '900ml',
  alimorca_6_name: 'Alimorca Aceite de Soya 1000ml',
  alimorca_6_pres: '1000ml',
  alimorca_7_name: 'Alimorca Aceite de Soya 9L',
  alimorca_7_pres: '9L',
  alimorca_8_name: 'Alimorca Aceite de Soya 18L',
  alimorca_8_pres: '18L',
  alimorca_p1_name: 'Alimorca Oleína de Palma 430ml',
  alimorca_p1_pres: '430ml',
  alimorca_p2_name: 'Alimorca Oleína de Palma 500ml',
  alimorca_p2_pres: '500ml',
  alimorca_p3_name: 'Alimorca Oleína de Palma 750ml',
  alimorca_p3_pres: '750ml',
  alimorca_p4_name: 'Alimorca Oleína de Palma 828ml',
  alimorca_p4_pres: '828ml',
  alimorca_p5_name: 'Alimorca Oleína de Palma 900ml',
  alimorca_p5_pres: '900ml',
  alimorca_p6_name: 'Alimorca Oleína de Palma 1000ml',
  alimorca_p6_pres: '1000ml',
  alimorca_p7_name: 'Alimorca Oleína de Palma 9L',
  alimorca_p7_pres: '9L',
  alimorca_p8_name: 'Alimorca Oleína de Palma 18L',
  alimorca_p8_pres: '18L',

  // Delsarten brand
  brand_del_name: 'Delsarten',
  brand_del_desc: 'Aceite de soya en las mismas presentaciones que Alimorca, bajo la marca Delsarten.',
  del_1_name: 'Delsarten Aceite de Soya 430ml',
  del_1_pres: '430ml',
  del_2_name: 'Delsarten Aceite de Soya 500ml',
  del_2_pres: '500ml',
  del_3_name: 'Delsarten Aceite de Soya 750ml',
  del_3_pres: '750ml',
  del_4_name: 'Delsarten Aceite de Soya 828ml',
  del_4_pres: '828ml',
  del_5_name: 'Delsarten Aceite de Soya 900ml',
  del_5_pres: '900ml',
  del_6_name: 'Delsarten Aceite de Soya 1000ml',
  del_6_pres: '1000ml',
  del_7_name: 'Delsarten Aceite de Soya 9L',
  del_7_pres: '9L',
  del_8_name: 'Delsarten Aceite de Soya 18L',
  del_8_pres: '18L',
  del_p1_name: 'Delsarten Oleína de Palma 430ml',
  del_p1_pres: '430ml',
  del_p2_name: 'Delsarten Oleína de Palma 500ml',
  del_p2_pres: '500ml',
  del_p3_name: 'Delsarten Oleína de Palma 750ml',
  del_p3_pres: '750ml',
  del_p4_name: 'Delsarten Oleína de Palma 828ml',
  del_p4_pres: '828ml',
  del_p5_name: 'Delsarten Oleína de Palma 900ml',
  del_p5_pres: '900ml',
  del_p6_name: 'Delsarten Oleína de Palma 1000ml',
  del_p6_pres: '1000ml',
  del_p7_name: 'Delsarten Oleína de Palma 9L',
  del_p7_pres: '9L',
  del_p8_name: 'Delsarten Oleína de Palma 18L',
  del_p8_pres: '18L',

  product_btn: 'Solicitar información',

  // CTA
  cta_quality_label: 'Calidad operativa',
  cta_quality_title: 'Envasado\ncon estándares\nindustriales',
  cta_title: '¿Necesitas un proveedor confiable?',
  cta_desc: 'Contáctanos y cuéntanos las necesidades de tu negocio. Estamos listos para atender pedidos de distribuidores, comercios y mayoristas.',
  cta_btn_info: 'Solicitar información',
  cta_btn_products: 'Ver productos',

  // Sectors
  sectors_label: 'Mercado',
  sectors_title: '¿A quién distribuimos?',
  sectors_subtitle: 'Atendemos distintos sectores del mercado hondureño con soluciones de suministro adaptadas a cada necesidad',

  sector_1_title: 'Distribuidores Mayoristas',
  sector_1_desc: 'Proveemos a distribuidores que abastecen múltiples puntos de venta a nivel regional y nacional.',

  sector_2_title: 'Supermercados y Tiendas',
  sector_2_desc: 'Abastecemos supermercados, pulperías y negocios de abarrotes con presentaciones adecuadas para venta al detalle.',

  sector_3_title: 'Industria Alimentaria',
  sector_3_desc: 'Suministramos aceite a granel y en presentaciones grandes para empresas del sector alimentario que lo usan como insumo.',

  sector_4_title: 'Restaurantes y Hoteles',
  sector_4_desc: 'Atendemos al sector de alimentos y hospitalidad con presentaciones en garrafa de 20L para uso intensivo.',

  sector_5_title: 'Mayoristas',
  sector_5_desc: 'Trabajamos con mayoristas que requieren volúmenes altos de producto con condiciones comerciales específicas.',

  sector_6_title: 'Instituciones y Programas',
  sector_6_desc: 'Abastecemos programas sociales, instituciones públicas y privadas con aceites bajo especificaciones requeridas.',

  sectors_cta_title: '¿Tu negocio no está en la lista?',
  sectors_cta_desc: 'Contáctanos y evalúa con nuestro equipo comercial si podemos atender tu necesidad de suministro de aceites',
  sectors_cta_btn: 'Solicitar información',

  // Location
  location_label: 'Nuestra Ubicación',
  location_title: 'Nuestra Ubicación',
  location_subtitle: 'Encuéntranos fácilmente y contáctanos',
  location_address_label: 'Dirección',
  location_email_label: 'Correo',
  location_phone_label: 'Teléfono',
  location_desc: 'Visítanos o contáctanos para conocer más sobre nuestros productos. Estamos disponibles para brindarte la mejor atención.',
  location_btn: 'Ver en Google Maps',

  // Contact
  contact_title: 'Contáctanos',
  contact_subtitle: 'Estamos aquí para ayudarte',
  contact_name: 'Nombre',
  contact_email: 'Correo Electrónico',
  contact_phone: 'Teléfono',
  contact_message: 'Mensaje',
  contact_submit: 'Enviar Mensaje',
  contact_sending: 'Enviando...',
  contact_success: '¡Mensaje enviado exitosamente! Nos pondremos en contacto pronto.',
  contact_error: 'Ocurrió un error al enviar. Por favor intenta nuevamente.',
  contact_chars: 'Máximo 500 caracteres',

  // Footer
  footer_tagline: 'Envasado, almacenamiento y distribución de aceites de calidad en Honduras.',
  footer_products_title: 'Productos',
  footer_palm: 'Aceite de Palma',
  footer_soya: 'Aceite de Soya',
  footer_presentations: 'Presentaciones',
  footer_company_title: 'Empresa',
  footer_about: 'Sobre Nosotros',
  footer_what: 'Qué Hacemos',
  footer_why: 'Por Qué Elegirnos',
  footer_contact_title: 'Contacto',
  footer_sectors: 'Sectores atendidos',
  footer_copyright: '© 2025 Merandia. Todos los derechos reservados.',
  footer_privacy: 'Privacidad',
  footer_terms: 'Términos',
};

export default es;
